import axios from "axios";
import Errores from "../utils/Errores.js";

let getListadoCarrerasTP = async function() {
  let url = API.INSTITUCIONES + "v1/comparador-carrera/filtros";
  let result = await axios
    .get(url)
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return result;
};

let getCarreraGenericaInfo = async function(carreraGenerica) {
  let url = API.INSTITUCIONES + "v1/comparador-carrera";
  let params = { carreraGenerica: carreraGenerica };
  let result = await axios
    .get(url, { params })
    .then(function(response) {
      return response.data;
    })
    .catch(function(error) {
      Errores.switchErrors(error);
      return null;
    });
  return result;
};

export default {
  getListadoCarrerasTP,
  getCarreraGenericaInfo
};



// WEBPACK FOOTER //
// ./src/services/ApiComparadorTP.js